export const GridLines = ({ hideMobile }: { hideMobile?: boolean }) => {
  return (
    <div
      className={`${hideMobile ? `hidden md:block` : ``} absolute top-0 left-0 w-full h-full z-0 bg-grid pointer-events-none`}
    />
  )
}
